import {
    NutAnalyticsClient,
    type AnalyticsConstant as CoreAnalyticsConstant,
} from 'nutshell-core/nut-analytics-client';

export type AnalyticsConstant = CoreAnalyticsConstant;

export const analyticsClient = new NutAnalyticsClient();
